import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  spaceL,
  spaceXL,
  spaceXXL,
  xdlColorTextSecondaryOnLight,
} from '@xing-com/tokens';

const HeaderVideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: ${spaceL} 0 ${spaceXXL};

  @media ${mediaSmallOrTiny} {
    margin: 0 -${spaceL} ${spaceXL};
  }
`;

const HeaderVideoCaption = styled.figcaption`
  align-self: center;
  color: ${xdlColorTextSecondaryOnLight};
  margin-top: ${spaceL};
`;

export const Styled = { HeaderVideoContainer, HeaderVideoCaption };
